// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".price-air-stat .el-form {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 28px;\n}\n.price-air-stat .el-form .el-form-item__content {\n    width: 190px;\n}\n", ""]);
// Exports
module.exports = exports;
